import curd from '../curd'

const BASE_PATH = '/pmf/factor'

export default curd(BASE_PATH, {
  sync: () => ({
    url: `${BASE_PATH}/sync`,
    method: 'PUT'
  })
})



// WEBPACK FOOTER //
// ./src/apis/modules/PMFFactor.js